
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DataComponentModelUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDataComponentModels"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataComponentModelUpdateInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDataPropertyDefinitions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataPropertyDefinitionUpdateInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDataRelationModels"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataRelationModelUpdateInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addDataPropertyTranslationMaps"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataPropertyTranslationMapAddInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeDataPropertyTranslationMaps"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDataComponentModels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dataComponentModels"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDataComponentModels"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updateDataPropertyDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dataPropertyDefinitions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDataPropertyDefinitions"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updateDataRelationModels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dataRelationModels"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDataRelationModels"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addDataPropertyTranslationMaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dataPropertyTranslationMaps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addDataPropertyTranslationMaps"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"removeDataPropertyTranslationMaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dataPropertyTranslationMapIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeDataPropertyTranslationMaps"}}}],"directives":[]}]}}],"loc":{"start":0,"end":839}};
    doc.loc.source = {"body":"mutation DataComponentModelUpdate(\n    $updateDataComponentModels: [DataComponentModelUpdateInput!]!,\n    $updateDataPropertyDefinitions: [DataPropertyDefinitionUpdateInput!]!,\n    $updateDataRelationModels: [DataRelationModelUpdateInput!]!,\n    $addDataPropertyTranslationMaps: [DataPropertyTranslationMapAddInput!]!,\n    $removeDataPropertyTranslationMaps: [ID!]!\n) {\n    updateDataComponentModels(dataComponentModels: $updateDataComponentModels)\n    updateDataPropertyDefinitions(dataPropertyDefinitions: $updateDataPropertyDefinitions)\n    updateDataRelationModels(dataRelationModels: $updateDataRelationModels)\n    addDataPropertyTranslationMaps(dataPropertyTranslationMaps: $addDataPropertyTranslationMaps) {\n        id\n    }\n    removeDataPropertyTranslationMaps(dataPropertyTranslationMapIds: $removeDataPropertyTranslationMaps)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DataComponentModelUpdate"] = oneQuery(doc, "DataComponentModelUpdate");
        
